module.exports = __webpack_public_path__ + "img/client-4--small.png?7acf1e833d9b72df7d1e79de211c0ce8";